import operator from './reducers';

export { default as switchActions } from './actions';
export { default as switchTypes }   from './types';

export default operator;
